import {AddressForm} from '@shopify/theme-addresses';

class AddressCard extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      collapsableAddressForm: '[data-collapsable-address-form]',
      addressForm: '[data-address-form]',
      addressFormFields: '[data-address-fields]',
      addressRequiredField: '[data-required]',
      addressCountry: '[name="address[country]"]',
      addressDeleteForm: '[data-address-delete-form]',
      addressCancel: '[data-address-cancel]',
      formTrigger: '[data-address-form-trigger]',
    };

    // Address form
    this.addressForm = this.querySelector(this.selectors.addressForm);
    this.addressFields = this.addressForm.querySelector(this.selectors.addressFormFields);

    // Opens or expands address form
    this.formTriggers = this.querySelectorAll(this.selectors.formTrigger);

    // Init Address Card
    this.initAddressForm();
    this.initCollapsableAddressForm();
  }

  initCollapsableAddressForm() {
    const collapsableAddressForm = this.querySelector(this.selectors.collapsableAddressForm);

    const showCollapsableAddressForm = (event) => {
      event.preventDefault();
      collapsableAddressForm.setAttribute('aria-expanded', 'true');
    };

    const hideCollapsableAddressForm = (event) => {
      event.preventDefault();
      collapsableAddressForm.setAttribute('aria-expanded', 'false');
    };

    this.formTriggers.forEach((trigger) => {
      trigger.addEventListener('click', showCollapsableAddressForm);
    });

    const cancelButton = this.querySelector(this.selectors.addressCancel);
    cancelButton?.addEventListener('click', hideCollapsableAddressForm);
  }

  initAddressForm() {
    AddressForm(this.addressFields, window.theme.locale.isoCode, {
      shippingCountriesOnly: this.addressFields.dataset.addressLimitCountries === 'true',
    });

    const countrySelector = this.addressFields.querySelector(this.selectors.addressCountry);
    countrySelector?.addEventListener('change', () => this.handleFieldVisibility());

    const deleteForm = this.querySelector(this.selectors.addressDeleteForm);
    deleteForm?.addEventListener('submit', this.handleAddressDelete);
  }

  handleFieldVisibility() {
    requestAnimationFrame(() => {
      const requiredFields = Array.from(this.addressFields.querySelectorAll(this.selectors.addressRequiredField));

      requiredFields.forEach((field) => {
        const parent = field.parentElement;
        if (parent.dataset.ariaHidden === 'true') {
          field.required = false;
          return;
        }
        field.required = true;
      });
    });
  }

  handleAddressDelete(event) {
    const confirmMessage = event.currentTarget.getAttribute('data-confirm-message');
    // eslint-disable-next-line no-alert
    if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      event.preventDefault();
    }
  }
}

export default function initAddressCards() {
  customElements.define('address-card', AddressCard);
}
